import React, { useEffect, useState } from "react";
import FlooringVoucherCard from "./FlooringVouchersCard";
import { useDispatch, useSelector } from "react-redux";
//import { setFlooringVoucherFilter } from "../../redux/slice/dealerCommFilterSlice";
import LoaderComp from "../../components/LoaderComp";
import axios from "../../helpers/axios";
import { FilterBy, SearchInput, Tab } from "../../components";
import SwitchBox from "../../components/SwitchBox";


const VehicleType = [
    { id: "", name: "All" },
    { id: "COE", name: "COE" },
    { id: "PARF", name: "PARF" },
    { id: "BODYONLY", name: "BODY ONLY" },
];

const CustomerType = [
    { id: 4, name: "All" },
    {
        name: "All Customer",
        id: 2,
    },
    {
        name: "First Time Customer",
        id: 0,
    },
    {
        name: "Returning Customer",
        id: 1,
    },
];
const DefaultFilters = {
    search_key: "",
    vehicle_type: "",
    customer_type: 4,
    is_featured: null,
    sortKey: "agentname",
    sortOrder: "asc",
    tabId: 0,
};
const FlooringVouchers = () => {
    const accessToken = localStorage.getItem("dealerModuleToken");
    const dispatch = useDispatch();
    const flooringVouchersFilter = useSelector(
        (state) => state?.dealerCommFilter?.flooringVouchersFilter
    );
    const [activeTab, setActiveTab] = useState(
        flooringVouchersFilter?.tabId !== undefined &&
            flooringVouchersFilter?.tabId !== ""
            ? flooringVouchersFilter?.tabId
            : DefaultFilters?.tabId
    );
    const [searchValue, setSearchValue] = useState("");
    const [flooringVouchers, setFlooringVouchers] = useState([]);
    const [flooringVoucherCount, setFlooringVoucherCount] = useState({});
    const [applyFilters, setApplyFilters] = useState(
        flooringVouchersFilter && Object.keys(flooringVouchersFilter).length > 0
            ? { ...DefaultFilters, ...flooringVouchersFilter }
            : DefaultFilters
    );
    const [loading, setLoading] = useState(false);

    const GetFlooringVouchers = async () => {
        const obj = {
            ...applyFilters,
            customer_type:
                applyFilters?.customer_type == 4 ? "" : applyFilters?.customer_type,
        };
        setLoading(true);
        try {


            const resp = await axios.post("admin/flooring/voucher/20/1", obj, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            if (resp?.status < 400) {
                //console.log("RESPONSE", resp);
                setFlooringVoucherCount(resp.data?.data?.count);
                setFlooringVouchers(resp.data?.data?.agents);
                setLoading(false);
            } else {
                setLoading(false);
            }
        } catch (err) {
            setLoading(false);

        }
    };

    const tabs = [
        `All Flooring Rates (${flooringVoucherCount?.flooring_rates_count})`,
        `Featured (${flooringVoucherCount?.featured_count})`,
    ];

    const HandleFilters = (key, value) => {
        //console.log("TYPE OF", typeof key === "object");
        setApplyFilters({
            ...applyFilters,
            ...key,
        });
        // dispatch(
        //     setFlooringVoucherFilter({
        //         ...applyFilters,
        //         ...key,
        //     })
        // );
    };

    const handleSearchChange = (e) => {
        setSearchValue(e.target.value);
        HandleFilters({ search_key: e.target.value });
    };

    const handleTabChange = (tabIndex) => {
        setActiveTab(tabIndex);
        if (tabIndex == 1) {
            HandleFilters({ is_featured: 1, tabId: tabIndex });
        } else {
            HandleFilters({ is_featured: null, tabId: tabIndex });
        }
    };

    const handleSettingsChange = (idx, title, tabId) => {
        HandleFilters({ vehicle_type: tabId });
    };
    const handleCustomerSettings = (idx, title, tabId) => {
        HandleFilters({ customer_type: tabId });
    };

    useEffect(() => {
        GetFlooringVouchers();
    }, [applyFilters]);
    //console.log("applyFilters", applyFilters);
    return (
        <section className="common_container">
            <header className="common-header flex justify-between">
                <div className="common-header-body">
                    <h1>Flooring Vouchers</h1>
                </div>
                <SearchInput onChange={handleSearchChange} value={searchValue} />
            </header>
            <section>
                <div className="tab-section">
                    <Tab
                        tabs={tabs}
                        activeTab={activeTab}
                        onTabChange={handleTabChange}
                    />
                </div>
                <section className="switch-box-section !pb-0">
                    <div>
                        <SwitchBox
                            title="Vehicle Type"
                            tabs={VehicleType}
                            settingsHandle={handleSettingsChange}
                            value={applyFilters?.vehicle_type}
                        />{" "}
                        <SwitchBox
                            title="Customer Type"
                            tabs={CustomerType}
                            settingsHandle={handleCustomerSettings}
                            value={applyFilters?.customer_type}
                        />
                    </div>
                </section>
                {loading ? (
                    <div className="tab-body-section">
                        <LoaderComp />
                    </div>
                ) : (
                    <div className="tab-body-section">
                        {activeTab === 0 && (
                            <FlooringVoucherCard flooringVouchers={flooringVouchers} />
                        )}
                        {activeTab === 1 && (
                            <FlooringVoucherCard flooringVouchers={flooringVouchers} />
                        )}
                    </div>
                )}
            </section>
        </section>
    );
};

export default FlooringVouchers;
